import * as React from 'react';

import type { ProductCard } from 'libs/apis/generated/models/ProductCard';
import ProductGrid from 'components/molecules/ProductGrid';
import ProductGridState from 'components/molecules/ProductGridState';
import LoadMoreTrigger from 'components/molecules/LoadMoreTrigger';
import CartButton from 'components/molecules/CartButton';

import FavoriteEmptyState from 'components/favorite/common/components/FavoriteEmptyState';
import useWishlistProducts from '../hooks/useWishlistProducts';
import classes from './WishlistProductsSection.scss';

type Props = {
  token: string;
  deviceType: 'sp' | 'pc';
  isLoginMember: boolean;
};

const EMPTY_DESCRIPTION = '商品が追加されるとこちらに表示されます。';

const renderCartAction = (product: ProductCard): React.ReactNode => {
  if (product.stock <= 0) {
    return <p className={classes['sold-out-text']}>完売しました</p>;
  }
  return (
    <CartButton
      productId={product.id}
      shouldShowSkuModal={product.hasOption}
      isGiftBox={product.isGiftBox}
    />
  );
};

const WishlistProductsSection: React.FC<Props> = ({ token, deviceType, isLoginMember }) => {
  const { state, viewState, loadMoreTriggerRef } = useWishlistProducts({ token });

  if (viewState !== 'content') {
    const isEmptyView = viewState === 'empty';
    return (
      <ProductGridState
        viewState={viewState}
        message={viewState === 'initial-error' ? state.error : null}
        emptyContent={isEmptyView ? <FavoriteEmptyState description={EMPTY_DESCRIPTION} /> : undefined}
      />
    );
  }

  return (
    <>
      <ProductGrid
        products={state.items}
        status={state.status}
        errorMessage={state.error}
        isPublished={true}
        deviceType={deviceType}
        renderAction={renderCartAction}
        shouldShowFavoriteLoginModal={!isLoginMember}
      />
      <LoadMoreTrigger
        isVisible={Boolean(state.nextPage)}
        triggerRef={loadMoreTriggerRef}
      />
    </>
  );
};

export default WishlistProductsSection;
